// extracted by mini-css-extract-plugin
export default {"root":"PlainMenu_root__1vSLk","placeHolderShimmer":"PlainMenu_placeHolderShimmer__nz8kT"};